import { render } from "./ImageExpandable.vue?vue&type=template&id=ba6761fc&scoped=true"
import script from "./ImageExpandable.vue?vue&type=script&lang=js"
export * from "./ImageExpandable.vue?vue&type=script&lang=js"

import "./ImageExpandable.vue?vue&type=style&index=0&id=ba6761fc&scoped=true&lang=css"

import exportComponent from "../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba6761fc"]])

export default __exports__